/* eslint-disable no-unused-vars */
import "./index.css";
import FieldComponentMeta from './Field/meta';
import AccordionComponentMeta from './Accordion/meta';
import ArrayComponentMeta from './Array/meta';
import MarkdownComponentMeta from './Markdown/meta';
import TextComponentMeta from './Text/meta';
import RowComponentMeta from './Row/meta';
import ColComponentMeta from './Col/meta';
import CardComponentMeta from './Card/meta';
import ImageComponentMeta from './Image/meta';
import ButtonComponentMeta from './Button/meta';
import ProgressComponentMeta from './Progress/meta';
import TagComponentMeta from './Tag/meta';
import SpacerComponentMeta from './Spacer/meta';
import ParagraphComponentMeta from './Paragraph/meta';
import TabsComponentMeta from './Tabs/meta';
import TabPaneComponentMeta from './TabPane/meta';
import ContainerComponentMeta from './Container/meta';
import ArrayTabsComponentMeta from './ArrayTabs/meta';
import FormComponentMeta from './Form/meta';
import FormItemComponentMeta from './FormItem/meta';
import FormAutoEditorComponentMeta from './FormAutoEditor/meta';
import FormUnsettledEditorComponentMeta from './FormUnsettledEditor/meta';
import TextInputComponentMeta from './TextInput/meta';
import NumberInputComponentMeta from './NumberInput/meta';
import CheckboxComponentMeta from './Checkbox/meta';
import SelectComponentMeta from './Select/meta';
import RadioComponentMeta from './Radio/meta';
import ColorPickerComponentMeta from './ColorPicker/meta';
import ArrayTableComponentMeta from './ArrayTable/meta';
import ConditionalContainerComponentMeta from './ConditionalContainer/meta';
import TriggerComponentMetas from './Triggers';
import FileUploaderComponentMeta from './FileUploader/meta';
import JSONViewComponentMeta from './JSONView/meta';
import AbsoluteComponentMeta from './AbsoluteContainer/meta';

/** @type {UICore.ComponentMeta[]} */
export const builtinComponents = [FormComponentMeta, FormItemComponentMeta, FormAutoEditorComponentMeta, FormUnsettledEditorComponentMeta,
// 下面这些是覆盖 DataSchema 原有组件的，使之更符合 UICore 的行为
TextInputComponentMeta, NumberInputComponentMeta, CheckboxComponentMeta, SelectComponentMeta, RadioComponentMeta, ColorPickerComponentMeta, ArrayTableComponentMeta, /* id: w-container*/ContainerComponentMeta, /* id: w-paragraph*/ParagraphComponentMeta, /* id: w-spacer   */SpacerComponentMeta, /* id: w-card     */CardComponentMeta, /* id: w-row      */RowComponentMeta, /* id: w-col      */ColComponentMeta, /* id: w-accordion*/AccordionComponentMeta, /* id: w-absolute */AbsoluteComponentMeta, ConditionalContainerComponentMeta, /* id: w-button   */ButtonComponentMeta, /* id: w-image    */ImageComponentMeta, /* id: text       */TextComponentMeta, /* id: markdown   */MarkdownComponentMeta, /* id: jsonView   */JSONViewComponentMeta, /* id: w-field    */FieldComponentMeta, /* id: w-array    */ArrayComponentMeta, /* id: w-array-tabs*/ArrayTabsComponentMeta, /* id: w-progress */ProgressComponentMeta, /* id: w-tag      */TagComponentMeta, /* id: w-spacer   */SpacerComponentMeta, /* id: w-tabs     */TabsComponentMeta, /* id: w-tab-pane */TabPaneComponentMeta, /* id: fileUploader */FileUploaderComponentMeta,
// -----------------------------------------------------------
// 下面是 触发器组件

...TriggerComponentMetas];